import { observable, action } from "mobx";
import { RequestState } from "src/models/RequestState";
import { TrendItem } from 'src/models/TrendItem.js';

export class ChartStore<T> {
    
    

    @observable public requestState: RequestState;
    @observable public error: string;
    @observable public data: T[]

    constructor() {
        this.init()
    }

    @action
    private init() {
        this.requestState = RequestState.NOT_ASKED;
        this.error = "";
        this.data = [];
    }

    @action
    public setData(data: T[]){
        this.data = data;
        this.requestState = RequestState.SUCCESS;
    }

    @action
    public setRequestState(status: RequestState): any {
        this.requestState = status; 
    }

    @action
    public setError(error: string) {
        this.error = error;
        this.requestState = RequestState.ERROR;
    }

}


// WEBPACK FOOTER //
// ./src/mobx/ChartStore.ts